import { render, staticRenderFns } from "./Sheets.vue?vue&type=template&id=a5d6ac84&scoped=true&"
import script from "./Sheets.vue?vue&type=script&lang=js&"
export * from "./Sheets.vue?vue&type=script&lang=js&"
import style0 from "./Sheets.vue?vue&type=style&index=0&id=a5d6ac84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d6ac84",
  null
  
)

export default component.exports